export default {
    fontSize: 12,
    marginTop: 5,
    color: '#909090',
};
